import { render, staticRenderFns } from "./messageDetailed.vue?vue&type=template&id=618cc3a9&scoped=true&"
import script from "./messageDetailed.vue?vue&type=script&lang=js&"
export * from "./messageDetailed.vue?vue&type=script&lang=js&"
import style0 from "./messageDetailed.vue?vue&type=style&index=0&id=618cc3a9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618cc3a9",
  null
  
)

export default component.exports